import { Box, Button } from '@mui/material';
import { getDatePickerFormat, getDateFnsLocale } from 'utils/format';
import { DatePicker } from '@mui/x-date-pickers';
import React, { FC, Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { invoiceDateVar } from 'apollo/reactive-variables/invoice';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

type OrderInvoiceFilterProps = {
    handleNext: () => void;
    clinicsLength: number;
};

const OrderInvoiceFilter: FC<OrderInvoiceFilterProps> = ({ handleNext, clinicsLength }: OrderInvoiceFilterProps) => {
    const { t: translate } = useTranslation(['orders', 'invoices']);
    const [orderToDate, setOrderToDate] = useState<Date | null>(invoiceDateVar().orderToDate);
    const [invoiceDate, setInvoiceDate] = useState<Date | null>(invoiceDateVar().invoiceDate);

    const handleClick = () => {
        handleNext();
    };

    const handleToDateChange = (date: Date | null) => {
        if (date !== null && date.toString() !== 'Invalid Date') {
            setOrderToDate(date as Date);
            invoiceDateVar(Object.assign(invoiceDateVar(), { orderToDate: date }));
            return;
        }
        setOrderToDate(null);
        invoiceDateVar(Object.assign(invoiceDateVar(), { orderToDate: null }));
    };

    const handleInvoiceDateChange = (date: Date | null) => {
        if (date !== null && date.toString() !== 'Invalid Date') {
            setInvoiceDate(date as Date);
            invoiceDateVar(Object.assign(invoiceDateVar(), { invoiceDate: date }));
            return;
        }
        setInvoiceDate(null);
        invoiceDateVar(Object.assign(invoiceDateVar(), { invoiceDate: null }));
    };

    return (
        <Fragment>
            <Box mb={2}>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={getDateFnsLocale()}>
                    <DatePicker
                        format={getDatePickerFormat()}
                        label={translate('invoices:ORDERS_READY_FOR')}
                        value={orderToDate}
                        onChange={handleToDateChange}
                        maxDate={new Date()}
                    />
                </LocalizationProvider>
            </Box>
            <Box mb={2}>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={getDateFnsLocale()}>
                    <DatePicker
                        format={getDatePickerFormat()}
                        label={translate('invoices:INVOICE_DATE')}
                        value={invoiceDate}
                        onChange={handleInvoiceDateChange}
                    />
                </LocalizationProvider>
            </Box>
            <Box>
                <Button
                    onClick={handleClick}
                    disabled={!clinicsLength || !invoiceDate || !orderToDate}
                    size="large"
                    fullWidth
                    variant="contained"
                >
                    {translate('orders:NEXT_STEP')}
                </Button>
            </Box>
        </Fragment>
    );
};

export default OrderInvoiceFilter;
